'use client';

interface RowPreviewProps {
  summary: string;
}

export function RowPreview({ summary }: RowPreviewProps) {
  if (!summary) return null;
  
  return (
    <div className="overflow-hidden max-h-0 opacity-0 group-hover:max-h-[48px] group-hover:opacity-100 group-focus-within:max-h-[48px] group-focus-within:opacity-100 transition-all duration-400 ease-out mt-1">
      <p className="text-xs text-muted-foreground line-clamp-2">
        {summary}
      </p>
    </div>
  );
}
